import { Component, OnDestroy, OnInit, ViewEncapsulation, ElementRef } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CoreConfigService } from '@core/services/config.service';
import { AuthenticationService } from '../../auth/service';

@Component({
  selector: 'vertical-layout',
  templateUrl: './vertical-layout.component.html',
  styleUrls: ['./vertical-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VerticalLayoutComponent implements OnInit, OnDestroy {
  coreConfig: any;
  completed_onboarding: boolean = false;
  isLogged: boolean = false;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
     * Constructor
     *
     * @param {CoreConfigService} _coreConfigService
     * @param _authenticationService
     */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _authenticationService: AuthenticationService,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
     * On init
     */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config: any) => {
      this.coreConfig = config;
    });

    const currentUser: any = this._authenticationService.currentUserValue;
    this.completed_onboarding = Boolean(currentUser.send_onboarding)
    this.isLogged = currentUser && currentUser.token;
  }

  /**
     * On destroy
     */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
